import React, { useState } from "react"
import { Button } from "react-bootstrap"
import { SigninApiTokenGet } from "./SigninApi"

import classes from "./Login.module.css";

import CloudCtiPng from '../Assets/CloudCTI.png';
import UserPng from '../Assets/user.png';
import PasswordPng from '../Assets/password.png';

import { jwtDecode } from "jwt-decode";
import axios from "axios";
const { v4: uuidv4 } = require('uuid');

export function Login(props) {
    const [mUser, SetUser] = useState(null)
    const [mPassword, SetPassword] = useState("")
    const [mErrorMessage, SetErrorMessage] = useState(props.Error)
    const [msErrorRef, SetMsErrorRef] = useState("");

    const SignIn = async (aUsername,aPassword) => {
        if (!aUsername || !aPassword) {
            SetErrorMessage(`Missing username or password`);
            return;
        }
        try 
        {
            var signinResult = await SigninApiTokenGet(aUsername,aPassword);
            if (signinResult.data)
            {
                if (signinResult.status === 200)
                {
                    if (signinResult.data.SecurityToken)
                    {
                        StoreToken(signinResult.data);
                        window.location.reload();
                    }
                }
                else
                {
                    let error = "";
                    try { error = signinResult.data.Exception; } catch {}
                    SetErrorMessage(error === "" ? "An error has occurred" : error);
                }
            }
            else
            {
                SetErrorMessage("An error has occurred");            
            }
        } 
        catch (ex) 
        {    
            let error = ex;
            try { error = ex.response.data.Exception; } catch {}
            SetErrorMessage(error === "" ? "An error has occurred" : error);
        }
    }

    return (   
        <table className={classes.main}>
            <tbody>
                <tr>
                    <td align="center" valign="center">
                        <table width="400" className={classes.login + ' foregroundElement'} cellPadding="12">
                            <tbody>
                                <tr>
                                    <td align="center"><img alt="" src={CloudCtiPng}/></td>
                                </tr>
                                <tr>
                                    <td align="center" className={classes.header}><p>Enter your CloudCTI credentials</p></td>
                                </tr>
                                <tr>
                                    <td>
                                        <table cellPadding="1" width="95%">
                                            <tbody>
                                                <tr height="8" className={classes.bordertop}/>
                                                <tr>
                                                    <td>
                                                        <img alt="" src={UserPng} width="20" height="20" className={classes.loginFieldIcon}/> &nbsp; <input className={classes.signininputfield} type="text" value={mUser === null ? ("") : mUser} onChange={evt => SetUser(evt.target.value)}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <img alt="" src={PasswordPng} width="20" height="20" className={classes.loginFieldIcon}/> &nbsp; <input className={classes.signininputfield} type="password" value={mPassword} onChange={evt => SetPassword(evt.target.value)} onKeyPress={(evt) => { if (evt.key === 'Enter') { SignIn(mUser,mPassword,"")}}}/>
                                                    </td>
                                                </tr>
                                                {mErrorMessage ? <tr style={{color:"red"}}><td align="center">{mErrorMessage}</td></tr> : <tr height="0"/>}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td align="center"><Button variant="primary" size="sm" onClick={() => SignIn(mUser,mPassword,"")} className={classes.signinbutton}><p>Sign In</p></Button></td>
                                </tr>
                                <tr>
                                    <td align="center">{"or"}</td>
                                </tr>
                                <tr>
                                    <td align="center"><Button variant="info" size="sm" onClick={MicrosoftLogin} className={classes.signinbutton}><p>{"Authorize with Microsoft"}</p></Button></td>
                                </tr>
                                <tr>
                                    <td align="center" style={{color:"red"}}>{msErrorRef}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>     
    );
  
    async function MicrosoftLogin()
    {
        const redirect_uri = "https://teamstokenservice.cloudcti.nl/release/auth/codeflow";
        //https://learn.microsoft.com/en-us/entra/identity-platform/v2-protocols#endpoints
        //https://login.microsoftonline.com/common/oauth2/v2.0/authorize

        // Make oAuth code request, forward it to the exchange server and get graph token
        const state = "client2020RogerApp" + uuidv4().substring(0, 8);
        var tab = window.open(`https://login.microsoftonline.com/common/oauth2/authorize?client_id=035773b7-d5ab-418f-879d-1fe96a64e172&response_type=code&redirect_uri=${redirect_uri}&response_mode=query&scope=openid&state=${state}`, '_blank');
        var graphToken;
        try {
            var pollingTriesLeft = 10; // Polling is 30s x 10, polls for max 5 minutes
            var segment1;
            while (pollingTriesLeft > 0) {
                segment1 = await fetch(`https://auth.cloudcti.nl/api/oauth/getcodeclient?state=${state + "1"}`)
                .then((response) => {
                    if (response.status == 204) { // return and retry
                        pollingTriesLeft--;
                        return;
                    }
                    else if (response.code == "Error") { // Something went wrong, abort retries
                        pollingTriesLeft = 0;
                        throw new Error();
                    }
                    else if (response.status == 200) {
                        pollingTriesLeft = 0;
                        return response.json();
                    }
                })
            }

            if (segment1 == undefined)
                throw new Error();

            // Only executed if segment1 was succesfully received
            const segment2 =  await fetch(`https://auth.cloudcti.nl/api/oauth/getcodeclient?state=${state + "2"}`)
            .then((response) => {
                if (response.status == 204 || response.code == "Error") // Something went wrong. If we're getting no reply after succesfully getting the first segment, that's also an issue
                    throw new Error();
                else if (response.status == 200)
                    return response.json();
            })
            graphToken = segment1.Code + segment2.Code;
        }
        catch (error) {
            SetMsErrorRef("Error while retrieving Microsoft session info."); // fail
            return;
        }

        // Exchange graph token for security token
        await axios.post("https://signin-va.cloudcti.nl/signin/api/teamstoken", {
            "SigninMethod":"microsoft",
            "CloudCTIUsername":"",
            "CloudCTIPassword":""
        },
        {
            headers: {
                Authorization: "Bearer " + graphToken,
                Accept: "application/json",
                ContentType: "application/json"
            }
        }).then((response) => {
            // Log in the user
            StoreToken(response.data); 
            try {
                tab.close();
            }
            catch (error) {
                console.log("Error while closing the oauth tab.");
                SetMsErrorRef("Tried to automatically close oauth window. This should only happen in an iframe."); // fail
            }
            window.location.reload();
        }).catch((error) => {
            SetMsErrorRef("Error while logging in User."); // fail
            return;
        });
    }
}


export function StoreToken(data) {
    localStorage.setItem("securityTokenCCTI0", data.SecurityToken)
}

export function GetStoredToken() {
    const token = localStorage.getItem('securityTokenCCTI0');
    return token
}

export function GetStoredTokenExp() {
    const token = localStorage.getItem('securityTokenCCTI0');
    const exp = jwtDecode(token).exp;
    const expireDate = new Date(exp * 1000); // .exp is in seconds, dates are in ms
    return expireDate;
}

export function RemoveStoredToken() {
    localStorage.removeItem('securityTokenCCTI0')
}